import React from "react";
import "./App.css";
import "./accessibility.css";

function App() {
  const whatsappUrl = "https://wa.me/5511947204615";

  return (
    <div>
      <header className="navHeader">
        <div className="componentesHeader">
          <img
            className="imgLogo"
            src={`${process.env.PUBLIC_URL}/iconeHeader.svg`}
            alt="Ícone do cabeçalho"
          />
        </div>

        <div className="icones">
          <a
            href="https://www.instagram.com/drajanecastanheira?igsh=MTNjZHc4cGV5bG44Yg=="
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className="imgInstagram"
              src={`${process.env.PUBLIC_URL}/instagram.png`}
              alt="Ícone do Instagram"
            />
          </a>

          <a
            href="https://www.facebook.com/share/1AbZ2Q3xFt/?mibextid=wwXIfr"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className="imgFacebook"
              src={`${process.env.PUBLIC_URL}/facebook.png`}
              alt="Ícone do Facebook"
            />
          </a>
        </div>
      </header>

      <main className="mainPag">
        <img
          className="imgRosto"
          src={`${process.env.PUBLIC_URL}/rosto.svg`}
          alt="Foto do rosto da Dra. Jane"
        />

        <section className="bodySection" id="minhaSessao">
          <div className="bodyDiv">
            <div className="divVazia"></div>

            {/* BOTÃO PRINCIPAL – CONTA CONVERSÃO */}
            <div className="divButton">
              <button
                type="button"
                className="btn"
                onClick={() => {
                  if (window.gtag_report_conversion) {
                    window.gtag_report_conversion(whatsappUrl);
                  } else {
                    window.open(whatsappUrl, "_blank");
                  }
                }}
              >
                Agende sua consulta
              </button>
            </div>

            <div className="divPhoto">
              <img
                className="foto01"
                src={`${process.env.PUBLIC_URL}/Imagem1.svg`}
                alt="Foto da Dra. Jane em sua mesa"
              />
            </div>
          </div>
        </section>

        <section className="textDrJane">
          <div className="textDr">
            <h1 className="nome">Dra. Jane Castanheira</h1>
            <h2 className="decricao">Harmonização Facial e Corporal</h2>
          </div>

          <section className="section_end">
            <header className="box_msg">
              <div className="box_msg_apres">
                <h2 className="msgapresention">
                  A Dra. Jane Castanheira é Cirurgiã-Dentista e Biomédica,
                  especialista em Harmonização facial e corporal, com
                  atendimento humanizado e técnicas modernas voltadas para
                  realçar sua beleza com naturalidade e segurança.
                </h2>
              </div>
            </header>

            <section className="box_tratamento">
              <div className="box_interno">
                <article className="txt_Tratamento">TRATAMENTOS</article>

                <article className="facial_corporal">
                  <h5 className="titulo_f_c">Facial e Corporal</h5>
                  <ul className="listaProcedimento">
                    <li>Toxina botulínica</li>
                    <li>Bioestimuladores de colágeno</li>
                    <li>Harmonização facial</li>
                    <li>Harmonização corporal</li>
                    <li>Lipoaspiração de papada</li>
                    <li>Fios de PDO</li>
                  </ul>
                </article>

                <article className="odontologia">
                  <h2 className="titulo_odon">Odontologia</h2>
                  <ul className="listaOdont">
                    <li>Clareamento dental</li>
                    <li>Gengivoplastia</li>
                    <li>Limpeza dental</li>
                    <li>Implante dental</li>
                  </ul>
                </article>
              </div>
            </section>

            <section className="box_localizacao">
              <div className="box_interno_local">
                <h3 className="txt_local">📍 Localização</h3>
                <p className="local_end">
                  Avenida Industrial, 780 – Sala 704 - Bairro Jardim, Santo
                  André – SP
                </p>
              </div>
            </section>

            {/* WHATSAPP FLUTUANTE – CONTA CONVERSÃO */}

            <button
              type="button"
              className="whatsapp-float"
              aria-label="Falar no WhatsApp"
              onClick={() => {
                if (window.gtag_report_conversion) {
                  window.gtag_report_conversion(whatsappUrl);
                } else {
                  window.open(whatsappUrl, "_blank");
                }
              }}
            >
              <img
                src={`${process.env.PUBLIC_URL}/whatsapp.png`}
                alt="WhatsApp"
              />
            </button>
          </section>
        </section>
      </main>
    </div>
  );
}

export default App;
